


export const useTcccStore = defineStore('tccc', () => {
    const sessionId = ref('')
    const callInPhone = ref('')
    const showTccc = ref(false)
    const hasTccc = ref(false)
    const callerLocation = ref('')
    const setShowTccc = (val)=>{
        showTccc.value = val;
    }
    const setSessionId = (val)=>{
        sessionId.value = val;
    }
    const setCallInPhone = (val)=>{
        callInPhone.value = val;
    }
    const setCallerLocation = (val)=>{
        callerLocation.value = val
    }
    const setHasTccc = (val) =>{
        hasTccc.value = val
    }
    return {
        sessionId,
        callInPhone,
        showTccc,
        callerLocation,
        hasTccc,
        setShowTccc,
        setSessionId,
        setCallInPhone,
        setCallerLocation,
        setHasTccc
    }
})
